import MainColorsScreen from './MainColorsScreen'

export default MainColorsScreen
